if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      this.pincodeServiceable = false; // Initialize as false by default
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      this.checkPincodeServiceability();
    }

    regularOperation() {
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response); });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    async checkPincodeServiceability() {
      await this.handleSubmitPostcode((success) => {
        this.pincodeServiceable = success;
        if (success) {
          this.regularOperation();
        } else {
    return; // Exit the function early if success is false
  }
      });
    }

    handleSubmitPostcode(callback) {
      const api_url = "https://gold-price-app.jewelyecom.in/postcode.php";
      const formData = {
        postcode: $("#postcode").val()
      };

      $.ajax({
        url: api_url,
        type: "POST",
        async: true,
        data: formData,
        crossDomain: true,
        success: function(response) {
          const data = $.parseJSON(response);
          let success = false;

          if (data.success_msg) {
            $('#response_message').html('<div class="success">' + data.success_msg + '</div>');
            success = true;
          } else {
            $('#response_message').html('<div class="error">' + data.err_msg + '</div>');
              $('#response_message')[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
           
          }

          $(".loading-image").hide();

          // Call the callback function with the success value
          callback(success);
        }
      });
    }
  });
}
